export var TooltipMode;
(function (TooltipMode) {
    TooltipMode[TooltipMode["CONTROLLED"] = 0] = "CONTROLLED";
    TooltipMode[TooltipMode["HOVERED"] = 1] = "HOVERED";
    TooltipMode[TooltipMode["FOCUSED"] = 2] = "FOCUSED";
})(TooltipMode || (TooltipMode = {}));
//# sourceMappingURL=tooltip.types.js.map